namespace RioERP.Orders {
    export namespace OrdershippingPendrivesService {
        export const baseUrl = 'Orders/OrdershippingPendrives';

        export declare function Create(request: Serenity.SaveRequest<OrdershippingPendrivesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrdershippingPendrivesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrdershippingPendrivesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrdershippingPendrivesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrdershippingPendrives/Create",
            Update = "Orders/OrdershippingPendrives/Update",
            Delete = "Orders/OrdershippingPendrives/Delete",
            Retrieve = "Orders/OrdershippingPendrives/Retrieve",
            List = "Orders/OrdershippingPendrives/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OrdershippingPendrivesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
